<template>
  <svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
    <line :style="top" x1="0" y1="0" x2="38" y2="0" stroke="currentColor" class="transition-all"/>
    <line :style="bottom" x1="0" y1="0" x2="38" y2="0" stroke="currentColor" class="transition-all"/>
  </svg>
</template>

<script>
export default {
  name: 'MenuIcon',
  props: {
    opened: Boolean
  },
  computed: {
    top () {
      if (this.opened) {
        return {
          transform: 'translateY(18%) rotate(45deg)'
        }
      }
      return { transform: 'translateY(38%) rotate(0)' }
    },
    bottom () {
      if (this.opened) {
        return {
          transform: 'translateY(88%) rotate(-45deg)'
        }
      }
      return { transform: 'translateY(62%) rotate(0)' }
    }
  }
}
</script>
